import { invokeApi } from "../../bl_libs/invokeApi";
const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2FiZDI0YzlhZmRiODcyY2JjMTE4ZTIiLCJsb2dpbl90b2tlbiI6ImJjY2ZmOTkwLWY4OTctMTFlZC04MmZlLTRkZjcyYTg5N2I0NCIsImxvZ2luX2J5IjoibWVtYmVyX3VzZXIiLCJpYXQiOjE2ODQ3NTY2MTB9.sEk8E2eDEPYOuL1IWytCrse8Pa_Plm5-zQmpJ34IgkU";

export const live_events_list_api = async () => {
  const requestObj = {
    path: `api/member/get_member_event/v1`,
    method: "GET",
    headers: {
      "x-sh-auth": token,
    },
  };
  return invokeApi(requestObj);
};
export const live_events_consultant_list_api = async () => {
  const requestObj = {
    path: `api/dynamite_event/list_delegate/events`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const live_events_consultant_admin_list_api = async (created_by) => {
  const requestObj = {
    path: `api/dynamite_event/portals/list?created_by=${created_by}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const add_dynamite_event_api = async (data) => {
  const requestObj = {
    path: `api/dynamite_event/`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const add_dynamite_event_api_new = async (data) => {
  const requestObj = {
    path: `api/dynamite_event/add_dynamite_event_by/delegate`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const delete_image_from_s3 = async (data) => {
  const requestObj = {
    path: `app/delete_image_on_s3_mutilple`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const _list_of_member_for_chat_against_event = async (
  event_slug,
  search_text
) => {
  const requestObj = {
    path: `api/chat/list_of_member_for_chat_against_event/v1/${event_slug}?search_text=${search_text}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const live_event_new_detail_api = async (id) => {
  const requestObj = {
    path: `api/member/get_member_event_detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": token, //changes done by zubair
    },
  };
  return invokeApi(requestObj);
};

export const get_member_event_detail_by_slug = async (event_id) => {
  const requestObj = {
    path: `api/member/get_member_event_detail_by_id/v1/${event_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": token,
    },
  };
  return invokeApi(requestObj);
};
export const get_delegate_event_detail_by_slug = async (event_id) => {
  const requestObj = {
    path: `api/dynamite_event/get_delegate_event_detail_by_id_v1/${event_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_lesson_detail_by_slug = async (event_id) => {
  const requestObj = {
    path: `api/dynamite_event_category_video_chat/chat/list/lesson/${event_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_image_on_s3_for_chat = async (data) => {
  const requestObj = {
    path: `app/update_image_on_s3_for_chat/`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_image_on_s3_for_chat = async (data) => {
  const requestObj = {
    path: `app/delete_image_on_s3_for_chat/`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
